import React from 'react';
import { ContentBlock, Button, SvgIcon } from 'seduo-ui';
import DropdownWithIcon from '../examples/DropdownWithIcon';
const Example = () => (<ContentBlock>
        <div className="d-flex flex-column flex-md-row justify-content-between">
            <div className="mb-7 mb-md-0">
                <Button color="info">
                    <span className="text-nowrap">
                        <SvgIcon kind="Filter" className="icon icon-white"/> Parametry
                    </span>
                </Button>
            </div>
            <div className="d-flex flex-column flex-md-row align-items-md-center">
                <span className="mr-4 text-nowrap">Řadit od</span>
                <DropdownWithIcon />
            </div>
        </div>
        <hr />
    </ContentBlock>);
export default Example;
